module.exports = __webpack_public_path__ + "static/img/6259_phase_function_Paper_Points.ee80e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6259_phase_function_Paper_Points.png
// module id = bao2
// module chunks = 0